import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e57e279"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "evaluate_form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Evaluate the need above based on the following criteria", -1))
const _hoisted_3 = { class: "card card-body border-0" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, " Does the submitted health priority need have strategic relevance to the national health priorities? ", -1))
const _hoisted_5 = { class: "radio" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "radio_text" }, "Low Relevance", -1))
const _hoisted_7 = { for: "relevance" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "radio_text" }, "High Relevance", -1))
const _hoisted_9 = { class: "card card-body border-0" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createTextVNode(" Quality of the submitted health need?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-light" }, "Score based on completeness, and clarity")
], -1))
const _hoisted_11 = { class: "radio" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "radio_text" }, "Lowest Quality", -1))
const _hoisted_13 = { for: "quality" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "radio_text" }, "Highest Quality", -1))
const _hoisted_15 = { class: "card card-body border-0" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Potential impact of addressing this health priority need.", -1))
const _hoisted_17 = { class: "radio" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "radio_text" }, "Lowest Impact", -1))
const _hoisted_19 = { for: "potential" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "radio_text" }, "Highest Impact", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "comment" }, [
  /*#__PURE__*/_createTextVNode("Comments"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-2" }, "*")
], -1))
const _hoisted_22 = { class: "w-100 text-muted d-flex justify-content-end mr-3" }
const _hoisted_23 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      name: "EvaluationForm",
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (item, i) => {
            return _createElementVNode("div", {
              class: "field-radiobutton",
              key: i
            }, [
              _createVNode(_component_RadioButton, {
                id: 'relevance' + i,
                name: "relevance",
                value: i + 1,
                modelValue: _ctx.form.relevance,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.relevance) = $event))
              }, null, 8, ["id", "value", "modelValue"]),
              _createElementVNode("label", _hoisted_7, _toDisplayString(i + 1), 1)
            ])
          }), 64)),
          _hoisted_8
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (item, i) => {
            return _createElementVNode("div", {
              class: "field-radiobutton",
              key: i
            }, [
              _createVNode(_component_RadioButton, {
                id: 'quality' + i,
                name: "quality",
                value: i + 1,
                modelValue: _ctx.form.quality,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.quality) = $event))
              }, null, 8, ["id", "value", "modelValue"]),
              _createElementVNode("label", _hoisted_13, _toDisplayString(i + 1), 1)
            ])
          }), 64)),
          _hoisted_14
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (item, i) => {
            return _createElementVNode("div", {
              class: "field-radiobutton",
              key: i
            }, [
              _createVNode(_component_RadioButton, {
                id: 'potential' + i,
                name: "potential",
                value: i + 1,
                modelValue: _ctx.form.potential,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.potential) = $event))
              }, null, 8, ["id", "value", "modelValue"]),
              _createElementVNode("label", _hoisted_19, _toDisplayString(i + 1), 1)
            ])
          }), 64)),
          _hoisted_20
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_21,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.form.comment,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.comment) = $event)),
          id: "comment",
          name: "comment",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here...",
          class: "w-100",
          maxlength: "200"
        }, null, 8, ["modelValue"]),
        _createElementVNode("small", _hoisted_22, _toDisplayString(_ctx.form.comment.length) + "/200", 1)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_BaseButton, {
          type: "submit",
          disabled: _ctx.loading,
          class: _normalizeClass({ submitting: _ctx.loading }),
          customStyle: _ctx.buttonStyle
        }, {
          default: _withCtx(() => [
            _createTextVNode("Submit Evaluation")
          ]),
          _: 1
        }, 8, ["disabled", "class", "customStyle"])
      ])
    ], 32)
  ]))
}